import { TypographyProps } from "@commonlibs";
import { css } from "styled-components";

export const getTypographyStyle = (variant: TypographyProps["variant"]) => {
    return css(({ theme }) => ({
        ...theme.typography[variant].style,
    }));
};
